
import { getDomainCfg, setDomainCfg } from "../state";

export const createQuestUrl = (questId : string) : string => {
  const domainCfg = getDomainCfg();
  const projectSettings = domainCfg.projectSettings;

  const questUrl = getQuestUrl(domainCfg, questId);
  domainCfg.projectSettings = {
    ...projectSettings,
    questUrl
  }
  setDomainCfg(domainCfg);
  return questUrl;
}

export const getQuestUrl = (domainCfg, questId) => {
  const projectSettings = domainCfg.projectSettings;
  const codeId = domainCfg.viewSettings.codeId;  
  return domainCfg.baseUrl + projectSettings.questPath + codeId + questId + ".json";
}
